import { orchestrator } from 'satcheljs';
import { formatSavedViews } from '../actions/privateActions';
import { getSavedCalendarViewsMap } from '../selectors/saveCalendarViewDataSelectors';
import { allCalendarAccountsAndCacheLoaded } from 'owa-calendar-account-store';

orchestrator(allCalendarAccountsAndCacheLoaded, actionMessage => {
    formatSavedViews(Array.from(getSavedCalendarViewsMap().values()));
});
